<!--
 * @Description: 商品列表
 * @version: 1.0.0
 * @Author: FJW
 * @Date: 2024-09-24 10:22:29
 * @LastEditors: FJW
 * @LastEditTime: 2024-12-11 09:01:46
-->
<template>
  <div>
    <!-- 搜索框 -->
    <div style="text-align: left;padding-right: 20px;" class="">
      <el-input class="search-text" placeholder="请输入商品名称" v-model="storeName" @keyup.enter.native="getPageSearch">
        <i class="el-icon-search el-input__icon" slot="prefix" style='cursor: pointer;' @click.stop="getPageSearch"></i>
      </el-input>
    </div>
    <!-- 主体 -->
    <div style="text-align: left;font-size: 14px;margin-top: 10px;color:#808080" v-if="tableData.length===0" key="1">暂无商品</div>
    <div style="margin-top: 10px;overflow-y: overlay;" v-el-height="{bottomOffset:90}" v-else key="2">
      <div v-for="item in tableData" :key="item.id" class="item_class flex flex-align-center">
        <div class="item_image flexShrink0">
          <!-- <img :src="item.image" alt="" style="width:100%;height: 100%;"> -->
          <el-image style="width: 100%; height: 100%" :src="item.image" :preview-src-list="[item.image]"></el-image>
        </div>
        <div style="margin-left: 20px;text-align: left" class="flex1">
          <div class="ellipsis" style="width: 260px;color:#66b1ff;cursor: pointer" :title="item.storeName" @click="routerToProductDetail(item)">{{item.storeName}}</div>
          <div class="flex flex-align-center">
            <div style="color: #ff602d;">￥{{item.price}}</div>
            <div style="color: #999;margin-left: 20px;">销量{{item.sales}}</div>
          </div>
          <div class="item_baby" @click="setShopDetail(item)">发送宝贝链接</div>
        </div>
      </div>
    </div>
    <!-- 分页功能 -->
    <Pagination :total="totalRecord" :page.sync="pageNo" :limit.sync="pageSize" @getPageChange="getPageChange" v-if="tableData.length>0" />
  </div>
</template>
  
<script>
export default {
  data() {
    return {
      totalRecord: 0, // 总数
      pageSize: 50, // 每页条数
      pageNo: 1, // 当前页码
      tableData: [],
      storeName: ''
    }
  },
  mounted() {
    this.getShopDetail()
  },
  methods: {
    // 跳转详情
    routerToProductDetail(data) {
      const params = {
        type: data.type,
        id: data.id
      }
      const queryString = new URLSearchParams(params).toString()
      const targetUrl = `${process.env.VUE_APP_SHOP_BASE_URL}/#/mall/product/form?${queryString}`;
      window.open(targetUrl, '_blank', 'width=1780,height=720,top=50, left=50')
    },

    // 发送商品详情
    setShopDetail(item) {
      this.$emit('sendRichTextMessage', item)
    },

    // 修改页数
    getPageChange(page) {
      this.pageSize = page.limit
      this.pageNo = page.page
      this.getShopDetail(true)
    },

    getPageSearch() {
      this.pageNo = 1
      this.getShopDetail(true)
    },

    // 获取商品列表
    getShopDetail(isSearch) {
      const queryParams = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        isShow: 1,
        stock: 1,
        cateId: 0,
        storeName: this.storeName
      }
      if (isSearch) {
        this.$isLoading.show()
      }
      this.$httpShop({
        url: '/product/store-product/page',
        method: 'get',
        params: queryParams
      }).then((res) => {
        this.$isLoading.close()
        this.tableData = res.data.list
        this.totalRecord = res.data.total
      })

    }
  }
}

</script>
<style rel='stylesheet/scss' lang='scss' scoped>
.item_class {
  background-color: #fff;
  margin-bottom: 20px;
  margin-right: 20px;
  border-radius: 10px;
  .item_image {
    width: 110px;
    height: 110px;
  }
  .item_baby {
    border: 1px solid #3d7fff;
    border-radius: 2px;
    color: #3d7fff;
    cursor: pointer;
    font-size: 10px;
    margin-top: 5px;
    text-align: center;
    width: 82px;
    padding: 3px 7px;
  }
}
</style>